export enum ETileSize {
  LARGE = 'LARGE',
  NORMAL = 'NORMAL',
  SLIM = 'SLIM',
  SHOP = 'SHOP', //4er Grid
  SHOP_SINGLE_MOBILE = 'SHOP_SINGLE_MOBILE',
  SHOP_ADVANCED = 'SHOP_ADVANCED', //1er Grid
  CAMPAIGN_SINGLE_MOBILE = 'CAMPAIGN_SINGLE_MOBILE',
}
